import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const ClientLoyaltyInfoBlock = styled('div')`
  width: 100%;
  height: fit-content;
  margin-top: 20px;
  overflow: auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 10px;
  padding: 10px;

  img {
    height: 85%;
  }

  .client-info-content {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 50px;

    .client-info-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;

      h2 {
        color: ${baseTheme.colors.mainLightBlue};
        text-align: center;
        margin: 0;
        font-size: 35px;
      }

      .actions {
        p {
          color: ${baseTheme.colors.focus};
          font-size: 30px;
          font-weight: 600;
          text-align: center;
          margin: 0 0 10px;
        }
      }
    }
  }
`;
